import { useEffect, useState } from "react";
import { filterByLocale } from "../../lib/edhub/localeFilter";
import { useClientTranslations } from "../../lib/i18n/client";
import {
	type EducationContent,
	fetchRecommendedContent,
	RECOMMENDED_FALLBACK,
} from "../../services/educationService";
import { RecommendedContent } from "../education/RecommendedContent";
import styles from "./HomeEducationSuggestions.module.css";

/**
 * D2C Home "Keep Exploring With Eve's Education Hub" block — reuses the
 * education RecommendedContent carousel + fetch service (same pattern as
 * EducationHub), with a mock fallback when the API returns nothing.
 */
export function HomeEducationSuggestions() {
	const { t, locale } = useClientTranslations("common");
	const [recommended, setRecommended] = useState<EducationContent[] | null>(
		null,
	);

	useEffect(() => {
		let cancelled = false;
		fetchRecommendedContent()
			.then((items) => {
				if (!cancelled)
					setRecommended(items.length > 0 ? items : RECOMMENDED_FALLBACK);
			})
			.catch(() => {
				if (!cancelled) setRecommended(RECOMMENDED_FALLBACK);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<h2 className={styles.heading}>
					{t("home.educationSuggestions.heading")}
				</h2>
				<p className={styles.subtitle}>
					{t("home.educationSuggestions.subtitle")}
				</p>
			</div>
			{recommended && (
				<div className={styles.carousel}>
					<RecommendedContent
						items={filterByLocale(recommended, locale)}
						contained
					/>
				</div>
			)}
		</section>
	);
}
